import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'us-registration-appliance-details-stepped-content-toggle',
  standalone: true,
  imports: [NgIf],
  templateUrl: './appliance-details-stepped-content-toggle.component.html',
  styleUrls: ['./appliance-details-stepped-content-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApplianceDetailsSteppedContentToggleComponent {
  @Input() toggleLabel = '';
  @Input() textBefore = '';
  displayContent = false;
  contentToggle() {
    this.displayContent = !this.displayContent;
  }
}
